import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await register(email, password, name);
      navigate("/", { replace: true });
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-6" data-testid="register-page">
      <div className="w-full max-w-sm">
        <p className="text-xs uppercase tracking-[0.4em] text-white/40 mb-3">Become a collector</p>
        <h1 className="font-serif text-4xl font-light mb-10">Create account</h1>

        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-white/40 block mb-1">Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input-minimal"
              data-testid="register-name"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-white/40 block mb-1">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-minimal"
              data-testid="register-email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.3em] text-white/40 block mb-1">Password</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-minimal"
              data-testid="register-password"
            />
          </div>

          {error && <p className="text-sm text-red-400" data-testid="register-error">{error}</p>}

          <button
            type="submit"
            disabled={busy}
            className="w-full bg-white text-black py-4 text-xs uppercase tracking-[0.3em] font-medium hover:bg-white/90 transition disabled:opacity-50"
            data-testid="register-submit"
          >
            {busy ? "Creating…" : "Create account"}
          </button>
        </form>

        <p className="text-sm text-white/50 mt-8 text-center">
          Already a collector?{" "}
          <Link to="/login" className="text-white underline-offset-4 hover:underline" data-testid="link-login">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
